
export function init() {
  const img = $('#img-main');
  const listImgChild = $('.img-child');

  listImgChild.on('mouseenter', function() {
    // Change url image product
    const imageUrl = $(this).attr('src');
    img.attr('src', imageUrl);
  });

  //handle click increase, decrease
  $(".quantity-button").on("click", function(e) {
    e.preventDefault();
    const action = $(this).data("action");
    const quantityInput = $("#quantity");

    const currentQuantity = parseInt(quantityInput.val());
    if (action === "increase") {
      quantityInput.val(currentQuantity + 1);
    } else if (action === "decrease" && currentQuantity > 1) {
      quantityInput.val(currentQuantity - 1);
    }
  });

  $(document).ready(function () {
      const radioInputSizes = document.querySelectorAll('.product-size');
      const price = $(".new-price");
      const oldPrice = $(".old-price");
      const available = $(".available");

      if (radioInputSizes.length !== 0) {
        price.text(radioInputSizes[0].getAttribute('newPrice')+ '₫');
        oldPrice.text(radioInputSizes[0].getAttribute('oldPrice')+ '₫');
        available.text(radioInputSizes[0].getAttribute('available') + ' sản phẩm có sẵn');
      }
      radioInputSizes.forEach(size => {
        size.addEventListener('click', function() {
            price.text(this.getAttribute('newPrice') + '₫');
            oldPrice.text(this.getAttribute('oldPrice') + '₫');
            available.text(this.getAttribute('available') + ' sản phẩm có sẵn');
          });
        });
      })
}
